export enum ClientEmployeeFileUploadTableColumns {
  fileName = "fileName",
  application = "application",
  employee = "employee",
  mimetype = "mimetype",
  uploadSize = "uploadSize",
  datetime = "datetime",
}

export const CLIENT_EMPLOYEE_FILE_UPLOAD_TABLE_COLUMN_LABELS: Record<ClientEmployeeFileUploadTableColumns, string> = {
  [ClientEmployeeFileUploadTableColumns.fileName]: "File Name",
  [ClientEmployeeFileUploadTableColumns.application]: "Application",
  [ClientEmployeeFileUploadTableColumns.employee]: "Employee",
  [ClientEmployeeFileUploadTableColumns.mimetype]: "Type",
  [ClientEmployeeFileUploadTableColumns.uploadSize]: "Size",
  [ClientEmployeeFileUploadTableColumns.datetime]: "Date/Time",
};

export const DEFAULT_CLIENT_EMPLOYEE_FILE_UPLOAD_TABLE_COLUMN_SETTINGS: Record<ClientEmployeeFileUploadTableColumns, boolean> = {
  [ClientEmployeeFileUploadTableColumns.fileName]: true,
  [ClientEmployeeFileUploadTableColumns.application]: true,
  [ClientEmployeeFileUploadTableColumns.employee]: true,
  [ClientEmployeeFileUploadTableColumns.mimetype]: true,
  [ClientEmployeeFileUploadTableColumns.uploadSize]: true,
  [ClientEmployeeFileUploadTableColumns.datetime]: true,
};

export const DEFAULT_CLIENT_EMPLOYEE_FILE_UPLOAD_TABLE_COLUMN_ORDER: ClientEmployeeFileUploadTableColumns[] = [
  ClientEmployeeFileUploadTableColumns.fileName,
  ClientEmployeeFileUploadTableColumns.application,
  ClientEmployeeFileUploadTableColumns.employee,
  ClientEmployeeFileUploadTableColumns.mimetype,
  ClientEmployeeFileUploadTableColumns.uploadSize,
  ClientEmployeeFileUploadTableColumns.datetime,
];

// Helper functions to generate derived data
export const getColumnLabels = (): Record<string, string> => CLIENT_EMPLOYEE_FILE_UPLOAD_TABLE_COLUMN_LABELS;
export const getDefaultColumnSettings = (): Record<string, boolean> => DEFAULT_CLIENT_EMPLOYEE_FILE_UPLOAD_TABLE_COLUMN_SETTINGS;
export const getDefaultColumnOrder = (): string[] => DEFAULT_CLIENT_EMPLOYEE_FILE_UPLOAD_TABLE_COLUMN_ORDER;